/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var _ = require('ES/lib/lodash');
var FormUtils = require('../../../utils/FormUtils');

var horizontal_fields_layout = [
	['building'],
	['address'],
	['city', 'st'],
	['zip', 'country'],
	['phone', 'timezone'],
	['fax', null]
];

var buildInitialValues = function(event, venue_id){
	var venue = _.first(_.filter(event && event.Venue, function(venue){
		return venue.id == venue_id;
	})) || {};
	return {
		address: venue.address || '',
		building: venue.building || '',
		city: venue.city || '',
		country: venue.country || 'US',
		fax: venue.fax || '',
		phone: venue.phone || '',
		st: venue.st || '',
		timezone: venue.timezone || '',
		zip: venue.zip || ''
	};
};

var buildFields = function(Displaylists, data){
	var u_lists = (Displaylists && Displaylists.universal) || {};

	return _.assign(FormUtils.buildAddressFields(Displaylists, data), {
		building: {
			label: 'Name',
			type: 'text',
			placeholder: 'Name...',
			validate: FormUtils.optional
		},
		timezone: {
			label: 'Timezone',
			type: 'select',
			placeholder: '-- local time --',
			options: _.object(_.map(u_lists.timezones, function(timezone){
				return [timezone, timezone];
			})),
			dont_sort_options: true,
			validate: FormUtils.optional
		},
		phone: {
			label: 'Phone',
			type: 'text',
			placeholder: 'Phone...',
			validate: FormUtils.optional
		},
		fax: {
			label: 'Fax',
			type: 'text',
			placeholder: 'Fax...',
			validate: FormUtils.optional
		}
	});
};

module.exports = {
	buildFields: buildFields,
	buildInitialValues: buildInitialValues,
	horizontal_fields_layout: horizontal_fields_layout
};



// WEBPACK FOOTER //
// ./src/components/widgets/venues/VenueForm.js